function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import Widget from 'components/Widget';
import NavTabs from 'components/NavTabs';
import ImportsHistory from '../ImportsHistory';
import ReadingsTable from '../ReadingsTable';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './MeasurementsTableWidget.pcss';
var _React_PureComponent;
class MeasurementsTableWidget extends (_React_PureComponent = React.PureComponent) {
    onChangeWidget(activeWidget) {
        this.setState({
            activeWidget
        });
    }
    get navTabsItems() {
        const navTabsItems = [];
        navTabsItems.push({
            label: messages.headers.measurementsTable,
            value: 'MeasurementsTable'
        });
        if (!this.props.isMyDownloadsHidden) {
            navTabsItems.push({
                label: messages.headers.myDownloads,
                value: 'ImportsHistory'
            });
        }
        return navTabsItems;
    }
    renderNavTabs() {
        if (this.props.isReadOnly) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: styles.navWrapper,
            children: /*#__PURE__*/ _jsx(NavTabs, {
                items: this.navTabsItems,
                activeItemValue: this.state.activeWidget,
                onClick: (value)=>this.onChangeWidget(value)
            })
        });
    }
    renderWidget() {
        const { activeWidget } = this.state;
        if (activeWidget === 'ImportsHistory') {
            return /*#__PURE__*/ _jsx(ImportsHistory, {
                phiSet: this.props.phiSet
            });
        }
        return /*#__PURE__*/ _jsx(ReadingsTable, {
            conversion: this.props.conversion,
            standards: this.props.standards,
            readings: this.props.readings,
            timeSeriesResources: this.props.timeSeriesResources,
            relatedData: this.props.relatedData,
            customRanges: this.props.customRanges,
            isReadOnly: this.props.isReadOnly,
            isInProgress: this.props.isInProgress
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Widget, {
            widgetId: constants.MEASUREMENTS_TABLE_WIDGET,
            isNoHeader: true,
            className: this.props.className,
            children: [
                this.renderNavTabs(),
                this.renderWidget()
            ]
        }, "MeasurementsTableWidget");
    }
    constructor(props){
        super(props);
        this.state = {
            activeWidget: 'MeasurementsTable'
        };
    }
}
_define_property(MeasurementsTableWidget, "propTypes", {
    // Explicit props
    phiSet: PropTypes.object,
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }).isRequired,
    readings: PropTypes.array,
    timeSeriesResources: PropTypes.array,
    relatedData: PropTypes.array,
    customRanges: PropTypes.array,
    isInProgress: PropTypes.bool,
    isMyDownloadsHidden: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    className: PropTypes.string
});
_define_property(MeasurementsTableWidget, "defaultProps", {
    className: ''
});
export default withStyles(styles)(MeasurementsTableWidget);
